import { useState } from "react";
import { insertTask, listTasks } from "../api/todo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

const AddTodo = ({ setTasks }) => {
  const [newTask, setNewTask] = useState("");
  const [showError, setShowError] = useState(false);

  const insertTaskHandler = () => {
    if (newTask === "") {
      setShowError(true);
    } else {
      insertTask(newTask);
      setNewTask("");
      setShowError(false);
      listTasks((data) => {
        setTasks(data);
      });
    }
  };

  return (
    <div>
      <div className="add-todo">
        <form className="input-form" onSubmit={insertTaskHandler}>
          <input
            type="text"
            name="newTask"
            value={newTask}
            onChange={(e) => setNewTask(e.target.value)}
            placeholder="Enter a title for this task..."
          />
          <FontAwesomeIcon
            className="plus"
            icon={faPlus}
            color="#EBC748"
            onClick={insertTaskHandler}
          />
        </form>
      </div>
      {showError && <div className="error">Please enter new task!</div>}
    </div>
  );
};

export default AddTodo;
